import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { closeJobPost } from '../../../services/operations/JobPostAPI';
import Loader from '../../loader/Loader';

const ConfirmationPopup = ({id,fetchJobs,onClose,filter,setFilter}) => {

  const dispatch=useDispatch()
  const token=useSelector((state)=>state.auth.token)
  const loading=useSelector((state)=>state.auth.loading)
 


  const handleStatus=async()=>{

         const payload = {
              job_status: "CLOSED"
            }
            await dispatch(closeJobPost(payload, token, id))
            setFilter(filter)
            fetchJobs()
            onClose()
    }  
  

  return (
    <div className="confirm-overlay">
        {loading && <Loader/>}
      <div className="confirm-content" >
        <h2>Close Job</h2>
        <p style={{color:"rgba(0, 0, 0, 0.5)",textAlign:"center"}}>Are you sure you want to close this job post, this action can not be undone.</p>
        <div className="confirm-action-button">
          <button className="cancel-btn-action" onClick={onClose}>Cancel</button>
          <button className="confirm-btn-action" onClick={handleStatus}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
